<template>
    <div class="list_item" @click="goDetailPage">
        <!-- Address  start -->
        <div class="item_cell cell">
            <div class="address">
                <a :href="cellData.link" rel="noopener noreferrer">{{
                    !isShowMask ? $ft.formatAddr(cellData.address) : $t('addressNotDisclosed')
                }}</a>
            </div>
        </div>
        <!-- Address end -->
        <!-- Sold Date start -->
        <div class="item_cell cell">
            <only-client>
                <span class="text_common">{{
                    $ft.formatDate(new Date(cellData.listDate), 'MM/dd/yyyy')
                }}</span>
            </only-client>
        </div>
        <!-- Sold Date end -->
        <!-- Sold PRICE start -->
        <div class="item_cell cell">
            <div class="sold_price t_right" v-if="!isShowMask">
                <template v-if="showPrice">
                    <div class="price">
                        {{
                            $ft.formatUnitNum(
                                cellData.showPrice,
                                false,
                                0,
                                currencySymbol
                            )
                        }}
                    </div>
                    <div
                        class="tendency"
                        :class="{
                            up: cellData.status > 0,
                            down: cellData.status < 0
                        }"
                    >
                        <div class="icon_container" v-if="cellData.status !== 0">
                            <div class="icon">
                                <span class="iconfont icon-expand"></span>
                            </div>
                            <span>{{ changePriceNum }}</span>
                        </div>
                    </div>
                </template>
                <div v-else class="empty-price">--</div>
            </div>
            <PriceMask class="sold_price t_right" v-else />
        </div>
        <!-- Sold PRICE end -->
    </div>
</template>

<script>
import common from '../../../_mixins/table-item/common';

export default {
    name: 'table-item',
    mixins: [common]
};
</script>

<style lang="scss">
.list-table-mb.template4{
    /* item_cell  The style settings under  start */
    .item_cell {
        font-family: var(--font-normal);
        padding: 14px 0;
        border-bottom: 1px solid var(--color-border);
        height: 100%;
        vertical-align: middle;
        &.cell {
            display: table-cell;
        }
        .address {
            padding-right: 30px;
            word-break: break-word;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-word;
            font-size: 12px;
            line-height: 1.5;
            color: var(--mg-title-color);
            letter-spacing: 1px;
        }
        .text_common {
            color: var(--color-info);
            letter-spacing: 1px;
        }
        .sold_price {
            white-space: nowrap;
            .price {
                font-size: 16px;
                font-weight: bold;
                line-height: 1.25;
                color: var(--color-label);
                margin-bottom: 6px;
            }
            .tendency {
                font-weight: bold;
                .icon_container {
                    display: flex;
                    align-items: center;
                }
                .iconfont {
                    font-size: 14px;
                }
                &.up {
                    color: #96efb4;
                    .icon {
                        transform: rotate(180deg);
                    }
                }
                &.down {
                    color: #ffb8b4;
                }
            }
            .empty-price{
                text-align: center;
            }
        }
    }
    .t_right {
        text-align: right;
    }
    /* item_cell  The style settings under  end */
}
</style>
